import { SxProps, Theme } from '@mui/material';
import { aiGradientTextSx } from 'common/constants/ai';

export const chipContainerSx: SxProps<Theme> = {
  display: 'inline-flex',
  alignItems: 'center',
  position: 'relative',
  height: 24,
  padding: '0 10px',
  borderRadius: '12px',
  cursor: 'pointer',
  backgroundColor: 'transparent',
  '&:hover': {
    backgroundColor: 'rgba(79, 85, 231, 0.06)',
  },
};

export const svgStyle: React.CSSProperties = {
  position: 'absolute',
  top: 0,
  left: 0,
  width: '100%',
  height: '100%',
  pointerEvents: 'none',
};

export const rectStyle: React.CSSProperties = {
  width: 'calc(100% - 2px)',
  height: 'calc(100% - 2px)',
};

export const labelTypographySx: SxProps<Theme> = {
  fontWeight: 500,
  fontSize: '0.8125rem',
  lineHeight: 1,
  ...(aiGradientTextSx as Record<string, unknown>),
};

export const commentaryListSx: SxProps<Theme> = {
  m: 0,
  pl: 2,
  mt: 0.5,
};

export const commentaryItemSx: SxProps<Theme> = {
  fontSize: '0.8rem',
  lineHeight: 1.5,
};
